import { Flex, Text } from '@chakra-ui/react';
import { Button } from '@morressier/alembic';
import ProtectedWorkflowAction from 'src/components/ProtectedAction/ProtectedWorkflowAction';
import ProtectedActionButton from '../../ProtectedAction/Button';
import { useSubmissionContextData } from 'src/contexts/SubmissionContextProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUserPlus } from '@fortawesome/pro-regular-svg-icons';

const EmptyReviewsTable = ({
  onInviteReviewer,
  onAssignReviewer,
  onAddBoardMembers,
  width,
  renderInviteCallToAction = true,
  title = 'No Reviewer(s) Yet Invited',
  description = 'Invite reviewers to assess this submission and help inform your decision.',
  entityId
}: {
  onInviteReviewer: () => void;
  onAssignReviewer: () => void;
  onAddBoardMembers?: () => void;
  width?: string;
  renderInviteCallToAction?: boolean;
  title?: string;
  description?: string;
  entityId: string;
}) => {
  const { submissionContext } = useSubmissionContextData();
  const isAssignReviewersEnabled = submissionContext?.config.assignReviewers;
  const isBoardMemberReviewerAssignmentEnabled =
    submissionContext?.config.boardMemberReviewerAssigment;

  return (
    <Flex
      flexDirection="column"
      gap={4}
      marginX="auto"
      bgColor="neutralPrimaryFill"
      marginTop={0}
      width={width}
    >
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingItem">{title}</Text>
        <Text textStyle="textBody">{description}</Text>
      </Flex>
      <Flex gap={4}>
        {renderInviteCallToAction && (
          <>
            <ProtectedWorkflowAction actionName="RequestReview">
              <Button
                onClick={onInviteReviewer}
                leftIcon={<FontAwesomeIcon icon={faEnvelope} />}
                variant="primary"
              >
                Invite Reviewers
              </Button>
            </ProtectedWorkflowAction>
            {isAssignReviewersEnabled && (
              <ProtectedActionButton
                relation="decision_maker"
                entityType="journal_phase"
                entityId={entityId}
                variant="secondary"
                onClick={onAssignReviewer}
              >
                Assign Reviewers
              </ProtectedActionButton>
            )}
            {onAddBoardMembers && isBoardMemberReviewerAssignmentEnabled && (
              <ProtectedWorkflowAction actionName="RequestReview">
                <Button
                  iconLeft={<FontAwesomeIcon icon={faUserPlus} />}
                  onClick={onAddBoardMembers}
                >
                  Assign Reviewers
                </Button>
              </ProtectedWorkflowAction>
            )}
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default EmptyReviewsTable;
